export const traditional = [
  {
    number: 'T001',
    hasModel: false
  },
  {
    number: 'T002',
    hasModel: false
  },
  {
    number: 'T003',
    hasModel: false
  },
  {
    number: 'T101',
    hasModel: false
  },
  {
    number: 'T102',
    hasModel: false
  },
  {
    number: 'T103',
    hasModel: false
  },
  {
    number: 'T104',
    hasModel: false
  },
  {
    number: 'T105',
    hasModel: false
  },
  {
    number: 'T106',
    hasModel: false
  },
  {
    number: 'T107',
    hasModel: false
  },
  {
    number: 'T108',
    hasModel: false
  },
  {
    number: 'T109',
    hasModel: false
  },
  {
    number: 'T110',
    hasModel: false
  },
  {
    number: 'T111',
    hasModel: false
  },
  {
    number: 'T112',
    hasModel: false
  },
  {
    number: 'T113',
    hasModel: false
  },
  {
    number: 'T114',
    hasModel: false
  },
  {
    number: 'T115',
    hasModel: false
  },
  {
    number: 'T116',
    hasModel: false
  },
  {
    number: 'T117',
    hasModel: false
  },
  {
    number: 'T118',
    hasModel: false
  },
  {
    number: 'T119',
    hasModel: false
  },
  {
    number: 'T120',
    hasModel: false
  },
  {
    number: 'T121',
    hasModel: false
  },
  {
    number: 'T122',
    hasModel: false
  },
  {
    number: 'T123',
    hasModel: false
  },
  {
    number: 'T124',
    hasModel: false
  },
  {
    number: 'T125',
    hasModel: false
  },
  {
    number: 'T126',
    hasModel: false
  },
  {
    number: 'T127',
    hasModel: false
  },
  {
    number: 'T128',
    hasModel: false
  },
  {
    number: 'T129',
    hasModel: false
  },
  {
    number: 'T130',
    hasModel: false
  },
  {
    number: 'T131',
    hasModel: false
  },
  {
    number: 'T132',
    hasModel: false
  },
  {
    number: 'T133',
    hasModel: false
  },
  {
    number: 'T134',
    hasModel: false
  },
  {
    number: 'T135',
    hasModel: false
  },
  {
    number: 'T136',
    hasModel: false
  },


]